import { render } from "./App.vue?vue&type=template&id=1085c7c4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1085c7c4&lang=scss"
script.render = render

export default script